import DefaultAuthorizationStore, { AuthorizationStore } from "authorization/store/AuthorizationStore";
import DefaultConfigStore, { ConfigStore } from "config/store/ConfigStore";
import { createContext, useContext } from "react";
import DefaultTasksStore, { TasksStore } from "../tasksBoard/store/TasksStore";
import DefaultTaskStatusesStore, { TaskStatusesStore } from "../taskStatuses/store/TaskStatusesStore";

export interface IStore {
    tasksStore: TasksStore;
    taskStatusesStore: TaskStatusesStore;
    authorizationStore: AuthorizationStore;
    configStore: ConfigStore;
}

export const stores: IStore = {
    tasksStore: DefaultTasksStore,
    taskStatusesStore: DefaultTaskStatusesStore,
    authorizationStore: DefaultAuthorizationStore,
    configStore: DefaultConfigStore,
};

export const StoreContext = createContext(stores);

export const useStore = () => {
    return useContext(StoreContext);
};
